import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsMndConstants {
    static STEP_TITLE = "Details";
    static APPLICATION_DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_LABEL = "Description";
    static TYPE_LABEL = "Application type";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static TYPE_FORM_CONTROL_NAME = "applicationType";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        type: {
            required: `Application type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
    };
}
